import React, { useRef, useEffect, useState, forwardRef, useImperativeHandle } from 'react'
import { SEditor, SLocalTreeSelected, STags } from 'shj-components'
import { Tabs, Form, Row, Col, Select, Input, Button, Card, Flex, Tooltip, message } from 'antd'
import { useLocation, useParams, useSearchParams } from 'react-router-dom'
import dayjs from 'dayjs'
import {
  getSelectGeneralTerm,
  getTradeEnums,
  listBrand,
  listProductCategory,
  queryActivity,
  selectBrandByGeneralTerm,
  selectQuoteBudgetDtlRefTypeEnum,
  generalSearch,
  additionSearch,
  projectSearch,
  queryActivityProduct,
  getListBudgetItem,
  getSubSearch,
  listProductSkuRelationSpuFormat,
  additionSearchPage,
  generalSearchPage,
  projectSearchPage,
} from '@/services/order'
import { treeToOneArr } from '@/common/utils.ts'
import styles from '../../index.module.less'
import noDataPage from '@/assets/no-data-page.png'
import { cloneDeep, isEmpty } from 'lodash'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import ModifyStandard from '@/pages/orderService/components/modifyStandard'
import _ from 'lodash'
import { useSetState } from 'ahooks'
import { productManagementDetail, productSkuDetail } from '@/services/product.ts'
import ProductDetailDrawer from '@/components/ProductDetailDrawer'
const { Meta } = Card;
export default forwardRef( function MaterialList ({
  setLoading = (a) => ({}),
  selectMaterialArray = [],
  spaceAllList = [],
  setSelectMaterialArray = a => ({}),
  pagination = {},
  setPagination = a => ({}),
},ref) {
  const params = useParams()
  const budgetId = params.budgetId //报价id
  const scrollContainerRef = useRef(null)
  const [materialList, setMaterialList] = useState<any>([])
  const [form] = Form.useForm()
  const [type, setType] = useState('')
  const [rootId, setRootId] = useState('')
  const [productCategoryIds, setProductCategoryIds] = useState<any>(undefined) // 分类
  const [templateList, setTemplateList] = useState([]) // 左侧 通项列表
  const [projectList, setProjectList] = useState<any[]>([])
  const [brandList, setBrandList] = useState<any>([])
  const [categoryList, setCategoryList] = useState<any>([]) // 产品分类列表数据
  const [activityList, setActivityList] = useState<any[]>([]) // 活动列表
  const [hasMore, setHasMore] = useState(true)
  const [generalStandardFlag, setGeneralStandardFlag] = useState(true)
  const [projectName, setProjectName] = useState('')
  const [subTypeList, setSubTypeList] = useState([]) // 减项类型枚举
  const [modifyLoading, setModifyLoading] = useState<boolean>(false) // 修改规格loading
  const [modifyStandardOpen, setModifyStandardOpen] = useState(false) // 修改规格
  const [currentModifyStandardArray, setCurrentModifyStandardArray] = useState<any>([]) // 当前修改规格数组
  const [skuList, setSkuList] = useState<any>([]) // 当前产品的sku map信息
  const [record, setRecord] = useState<any>({}) // 当前产品信息
  const [tabItems, setTabItems] = useState([
    {
      key: 'GENERAL',
      label: '通项选材',
    },
    {
      key: 'PROJECT',
      label: '项目选材',
    },
    {
      key: 'ADD',
      label: '增项',
    },
    {
      key: 'SUB',
      label: '减项',
    },
    {
      key: 'ACTIVITY',
      label: '优惠活动',
    },
  ])
  const [state, setState] = useSetState<any>({
    open: false,
    loading: false,
    descType: [],
    data: {},
  })
  useEffect(() => {
    getTypeList()
  }, [])

  useEffect(() => {
    if (!type) {
      return
    }
    form.resetFields()
    setProductCategoryIds([])
    switch (type) {
      case 'GENERAL':
        fetchTemplateList()
        break
      case 'ADD':
        fetchCategoryList()
        // 品牌默认获取
        fetchBrandList()
        fetchList('', [])
        break
      case 'SUB':
        fetchList('', [])
        break
      case 'PROJECT':
        getProjectList()
        fetchCategoryList()
        // 品牌默认获取
        fetchBrandList()
        break
      case 'ACTIVITY':
        fetchActivityList()
        // 品牌默认获取
        fetchBrandList()
        break
      default:
        break
    }
  }, [type])

  useImperativeHandle( ref,
    () => ({
      fetchList:(...args:any)=>{
        fetchList(...args)
      },
      type:type,
    }),
    [type])
  // 获取列表明细
  const fetchList = async (lastId = '', categoryIds?: any,pageParams?:any) => {
    setLoading(true)
    // 品牌搜索处理：
    // values.brand = values.brand === "不限" ? "" : values.brand;
    const pageInfo = pageParams || {
        current: 1,
        pageSize: 10,
    }
    const values = form.getFieldsValue()
    try {
      let data
      switch (type) {
        case 'GENERAL':
          // 通项选材
          if (!values.general) {
            setLoading(false)
            return
          }
          data = await generalSearchPage({
            data: {
              searchKeyWord: values.search,
              brandId: values.brand,
              type,
              generalId: values.general,
              quoteBudgetId: budgetId,
              ...pageInfo,
            },
          })
             setPagination({
          pageSize: Number( data?.pageSize || 10),
          current:Number(data?.currentPageId || 1),
          total: data?.count,
        })
          data = data?.list || []
          break
        case 'PROJECT':
          // 项目选材
          if (!values.quoteBudgetItemId) {
            setLoading(false)
            return
          }
          data = await projectSearchPage({
            data: {
              searchKeyWord: values.search,
              type,
              brandId: values.brand,
              quoteBudgetId: budgetId,
              quoteBudgetItemId: values.quoteBudgetItemId,
              productCategoryIds: categoryIds || productCategoryIds,
              ...pageInfo,
            },
          })
           setPagination({
          pageSize: Number( data?.pageSize || 10),
          current:Number(data?.currentPageId || 1),
          total: data?.count,
        })
          data = data?.list || []
          break
        case 'ADD':
          // 增项选材
          delete values.templateCommonSkuCode
          data = await additionSearchPage({
            data: {
              searchKeyWord: values.search,
              quoteBudgetId: budgetId,
              type,
              brandId: values.brand,
              productCategoryIds: categoryIds || productCategoryIds,
              ...pageInfo,
            },
          })
          setPagination({
          pageSize: Number( data?.pageSize || 10),
          current:Number(data?.currentPageId || 1),
          total: data?.count,
        })
          data = data?.list || []
          break
        case 'SUB':
          // 减项选材
          delete values.templateCommonSkuCode
          data = await getSubSearch({
            data: {
              searchKeyWord: values.search,
              quoteBudgetId: budgetId,
              type,
              pageSize: 999,
              // preBusId: lastId,
              quoteBudgetItemId: values.quoteBudgetItemId || '',
            },
          })
          break
        case 'ACTIVITY':
          //优惠活动
          data = await queryActivityProduct({
            data: {
              searchKeyWord: values.search,
              activityId: values.activity || '',
              quoteBudgetId: budgetId,
              type,
              pageSize: 15,
              // preBusId: lastId,
              brandId: values.brand,
            },
          })
          break
        default:
          break
      }
      dataHanlder(data)
      setLoading(false)
    } catch (e) {
      // setHasMore(false)
      dataHanlder([])
      setLoading(false)
    }
  }

  // 数据处理方法
  const dataHanlder = (newData: any,) => {
    if (Array.isArray(newData)) {
      newData.forEach((item: any) => {
        item.expanded = false
        item.checkNumber = 0
        item.id = item.productSkuId
        item.rootId = rootId
        item.rightMenuCode = type
        item.generalStandardFlag = generalStandardFlag

        if (type !== 'PROJECT' && !item.budgetItemList?.length) {
          item.budgetItemList = [
            {
              id: rootId,
              isRoot: true,
              name: '',
            },
          ]
        }

        if (type === 'SUB') {
          item.spaceChecked = [item?.budgetItemList?.[0]?.id]
        }
      })
      // if (lastId) {
      //   // 这里加载下一页用的上一页最后一个元素的ID去加载，所以下一页第一个元素是上一页最后一个元素
      //   const concatList = materialList?.concat(newData.slice(1))
      //   setMaterialList(concatList)
      //   return
      // }
      setMaterialList(newData)
    }
  }

  const getTypeList = async () => {
    try {
      const res = await selectQuoteBudgetDtlRefTypeEnum({ budgetId })
      if (Array.isArray(res)) {
        const list = res
          .filter(item => item.code !== 'UP_DOWN')
          ?.map(item => ({ key: item.code, label: item.desc, id: item.id }))
        setTabItems(list)
        setType(list?.[0]?.key)
        setRootId(list?.[0]?.id)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleTabChange = (value: any) => {
    scrollContainerRef.current?.scrollTo(0, 0)
    setMaterialList([])
    setType(value)
    const selectList = tabItems.filter(item => item.key === value)
    setRootId(selectList?.[0]?.id)
  }

  // 获取通项下拉数据
  const fetchTemplateList = async () => {
    const res: any = await getSelectGeneralTerm({
      data: {
        quoteBudgetId: budgetId,
        isUpDown: type === 'UP_DOWN',
      },
    })
    form.setFieldValue('general', res?.[0]?.id)
    setTemplateList(res)

    // 根据通项查品牌
    selectBrandByGeneralTerm({
      data: {
        generalItemManageId: type === 'GENERAL' ? res?.[0]?.id : '',
        quoteBudgetId: budgetId,
      },
    }).then(res => {
      let array = Array.isArray(res) ? res : []
      array = array.map(item => {
        return {
          label: item.sourceName,
          value: item.sourceId,
        }
      })
      setBrandList([{ label: '不限', value: '' }, ...array])
      form.setFieldValue('brand', '')
    })

    fetchList()
  }

  //  树结构数据处理
  const handleTreeData = data => {
    if (Array.isArray(data)) {
      data.map(item => {
        item.title = item.label
        item.value = item.id
        if (item.children && item.children.length) {
          handleTreeData(item.children)
        }
      })
    }
    return data
  }

  // 获取分类下拉数据
  const fetchCategoryList = async () => {
    const res: Array<any> = await listProductCategory({
      data: {
        quoteBudgetId: budgetId,
      },
    })
    const data = handleTreeData(res?.filter(item => item.label !== '整装产品') || [])
    setCategoryList(data)
  }

  // 获取品牌数据
  const fetchBrandList = async () => {
    listBrand({
      data: {
        quoteBudgetId: budgetId,
      },
    }).then(res => {
      let array = Array.isArray(res) ? res : []
      array = array.map(item => {
        return {
          label: item.sourceName,
          value: item.sourceId,
        }
      })
      setBrandList([{ label: '不限', value: '' }, ...array])
      form.setFieldValue('brand', '')
    })
  }

  // 获取活动数据
  const fetchActivityList = async () => {
    let activityList: any = await queryActivity({
      params: {
        budgetId: budgetId,
      },
    })
    activityList = activityList.map(item => {
      return {
        label: item.name,
        value: item.id,
      }
    })
    form.setFieldValue('activity', '')
    setActivityList([{ label: '不限', value: '' }, ...activityList])
    fetchList()
  }
  // 获取减项类型
  const fetchSubTypeList = async () => {
    const res = await getTradeEnums('com.shj.saas.plus.trade.enums.SubtractTypeEnum')
    setSubTypeList(res)
    form.setFieldValue('subType', res[0]?.key)
  }

  const handleScroll = () => {
    // const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current
    // if (scrollTop + clientHeight >= scrollHeight) {
    //   // 触底时加载更多数据
    //   if (hasMore) {
    //     fetchList(materialList?.[materialList?.length - 1]?.productSpu?.id)
    //   }
    // }
  }

  const productCategoryChange = e => {
    let ids: any = []
    if (e) {
      let newList = treeToOneArr(categoryList)
      let infoObj: any = newList.find(item => item.id === e)
      findAllId(infoObj, ids)
    }
    setProductCategoryIds(ids)
    fetchList('', ids)
  }
  const findAllId = (obj: any, ids) => {
    ids.push(obj.id)
    if (obj.children && obj.children.length > 0) {
      obj.children.forEach(item => {
        findAllId(item, ids)
      })
    }
  }

  const getProjectList = async () => {
    try {
      const res: any = await getListBudgetItem({ quoteBudgetId: budgetId })
      if (Array.isArray(res)) {
        const newList = res.map(item => ({ value: item.sourceId, label: item.sourceName }))
        setProjectList(newList)
        form.setFieldValue('quoteBudgetItemId', newList?.[0]?.value)
        setProjectName(newList?.[0]?.label)
        fetchList()
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleChangeGeneral = async (value: any) => {
    form.setFieldValue('search', '')
    // 根据通项查品牌
    selectBrandByGeneralTerm({
      data: { generalItemManageId: type === 'GENERAL' ? value : '', quoteBudgetId: budgetId },
    }).then(res => {
      let array = Array.isArray(res) ? res : []
      array = array.map(item => {
        return {
          label: item.sourceName,
          value: item.sourceId,
        }
      })
      setBrandList([{ label: '不限', value: '' }, ...array])
      form.setFieldValue('brand', '')
    })
    const generalStandardFlag =
      templateList.filter((item: any) => item.id === value)?.[0]?.generalStandardFlag || true
    setGeneralStandardFlag(generalStandardFlag)

    fetchList()
  }

  const handleChangeProject = async (value: any) => {
    form.setFieldValue('search', '')
    const selectProject = projectList?.filter((item: any) => item.value === value)
    const label = selectProject?.[0]?.label
    setProjectName(label)
    fetchList()
  }

  const handleChangeBrand = () => {
    fetchList()
  }

  const handleChangeRoom = () => {
    fetchList()
  }

  const handleChangeActivity = () => {
    fetchList()
  }

  const handleSearch = () => {
    fetchList()
  }

  const handleChoose = (item: any, index: number) => {
    let newData = cloneDeep(materialList)
    // newData[index].checked = true;
    // 如果选材为标配 升降级 需要传参通项Id
    const values = form.getFieldsValue()
    if (type === 'GENERAL' || type === 'UP_DOWN') {
      newData[index].generalId = values.general || ''
    }
    if (type === 'PROJECT') {
      newData[index].quoteBudgetItemId = values.quoteBudgetItemId || ''
      newData[index].quoteBudgetItemName = projectName || ''
    }
    newData[index].spaceChecked = newData[index].spaceChecked || []
    const array: any[] = cloneDeep(selectMaterialArray)
    // 如果有多规格 提前做选择
    if (
      item.rightMenuCode !== 'SUB' &&
      item.productSpu?.prodType !== 'PRODUCT_GROUP' &&
      item.productSpu?.skuList?.length > 1
    ) {
      setRecord(newData[index])
      handleOpenSpecsDialog(newData[index])
    } else {
      array.push({ ...newData[index], checked: true })
      message.success('选择成功，已加入选材车')
      setSelectMaterialArray(array)
    }
  }
  const handleOpenSpecsDialog = async (record: any) => {
    console.log(record)
    setModifyStandardOpen(true)
    setModifyLoading(true)
    // setCurrentIndex(index)
    let dynaOptions
    let resData
    try {
      resData = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          productSpuId: record.productSpuId,
          generalId:
            record.rightMenuCode === 'UP_DOWN' || record.rightMenuCode === 'GENERAL'
              ? record.generalId || null
              : null,
          priceCalcType: record.rightMenuCode === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId: record?.activityProduct?.id || null,
        },
      })
    } catch {
      setModifyLoading(false)
    }
    setModifyLoading(false)
    dynaOptions = record.dynaOptions
    setSkuList(resData.skuList)
    resData.specificationArgList?.map((item: any) => {
      if (!isEmpty(dynaOptions)) {
        item.argValId = dynaOptions[item.argCode].valueId
        item.argValName = dynaOptions[item.argCode].valueName
      }
      item.options = item?.values.map((ol: any) => {
        return {
          ...ol,
          argValId: ol.valueId,
          argValName: ol.valueName,
        }
      })
      return item
    })
    setCurrentModifyStandardArray(resData.specificationArgList || [])
  }

  const onSubmitModifyStandard = async value => {
    let selectObj = {}
    let newRecord: any = _.cloneDeep(record)
    let newSkuObj: any = {}
    const array: any[] = cloneDeep(selectMaterialArray)

    value.forEach((item: any) => {
      selectObj[item.argCode] = {
        argValId: item.argValId,
        argValName: item.argValName,
      }
    })
    // 确定sku
    skuList.forEach((item: any) => {
      let flag = true
      for (let key in selectObj) {
        if (item.argMap[key].valueId !== selectObj[key].argValId) {
          flag = false
        }
      }
      if (flag) {
        newSkuObj = item
      }
    })
    // 选材之后确定SKU码
    newRecord.dynaOptions = newSkuObj.argMap
    newRecord.productSkuName = newSkuObj.skuName
    newRecord.productSkuPrimaryImage = newSkuObj?.mainPicUrl || newRecord.productSkuPrimaryImage
    newRecord.productSkuSalePrice = newSkuObj.priceInfo?.customerPrice
    newRecord.productSkuId = newSkuObj.id
    newRecord.productSku = newSkuObj
    newRecord.longDesc = newSkuObj?.longDesc
    array.push({ ...record, ...newRecord, checked: true })
    console.log(array);
    message.success('选择成功，已加入选材车')
    setSelectMaterialArray(array)
  }

  const handleShowSpuDetail = (data: any) => {
    setState({ open: true, loading: true })
    let api = type === 'SUB' || type === 'ACTIVITY' ? productSkuDetail : productManagementDetail
    let id = type === 'SUB' || type === 'ACTIVITY' ? data.productSkuId : data.productSpuId
    api(id)
      .then(res => {
        setState({ data: res })
      })
      .finally(() => setState({ loading: false }))
  }

  return (
    <div className={styles.chooseMaterialModal}>
      <Tabs activeKey={type} items={tabItems} onChange={handleTabChange} />
      <Form layout="vertical" form={form}>
        <Row gutter={[0, 0]}>
          {type === 'GENERAL' ? (
            <Col span={7} style={{ marginRight: '15px' }}>
              <Form.Item label="通项" name="general">
                <Select
                  onChange={e => {
                    handleChangeGeneral(e)
                  }}
                  options={templateList}
                  placeholder="请选择"
                  fieldNames={{ label: 'name', value: 'id' }}
                ></Select>
              </Form.Item>
            </Col>
          ) : null}
          {type === 'PROJECT' ? (
            <Col span={7} style={{ marginRight: '15px' }}>
              <Form.Item label="项目" name="quoteBudgetItemId">
                <Select
                  onChange={e => {
                    handleChangeProject(e)
                  }}
                  options={projectList}
                  placeholder="请选择"
                ></Select>
              </Form.Item>
            </Col>
          ) : null}
          {type === 'ADD' || type === 'PROJECT' ? (
            <Col span={7} style={{ marginRight: '15px' }}>
              <Form.Item label="产品分类" name="productCategoryIds">
                <SLocalTreeSelected
                  placeholder="请选择"
                  onChange={(value: string) => productCategoryChange(value)}
                  treeData={categoryList}
                />
              </Form.Item>
            </Col>
          ) : null}
          {type === 'SUB' ? (
            <Col span={7} style={{ marginRight: '15px' }}>
              <Form.Item label="所在位置" name="quoteBudgetItemId">
                <Select
                  options={spaceAllList}
                  placeholder="请选择"
                  onChange={(value: string) => handleChangeRoom()}
                  fieldNames={{ label: 'showName', value: 'id' }}
                  allowClear
                ></Select>
              </Form.Item>
            </Col>
          ) : null}
          {type === 'ACTIVITY' ? (
            <Col span={7} style={{ marginRight: '15px' }}>
              <Form.Item label="所属活动" name="activity">
                <Select
                  showSearch
                  options={activityList}
                  onChange={(value: string) => handleChangeActivity()}
                  placeholder="请选择"
                  optionFilterProp="label"
                ></Select>
              </Form.Item>
            </Col>
          ) : null}
          {type !== 'ACTIVITY' && type !== 'SUB' ? (
            <Col span={7} style={{ marginRight: '15px' }}>
              <Form.Item label="品牌" name="brand">
                <Select
                  options={brandList}
                  onChange={(value: string) => handleChangeBrand()}
                  placeholder="请选择"
                  showSearch
                  optionFilterProp={'label'}
                ></Select>
              </Form.Item>
            </Col>
          ) : null}
          <Col span={8} style={{ display: 'flex' }}>
            <Form.Item label='搜索' name='search' style={{ flex: '1'}}>
              <Input placeholder={  ['SUB', 'ACTIVITY'].includes(type) ? '产品SKU名称/SKU_ID' : '产品SPU名称/SPU_ID/SKU_ID/物料ID'} style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}></Input>
            </Form.Item>
            <Form.Item label={' '} style={{ width: '65px' }}>
              <Button
                type="primary"
                onClick={handleSearch}
                style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
              >
                搜索
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      { type === 'SUB' ? <div>
        <div style={{ marginBottom: 10, backgroundColor: '#fff', color: 'gray' }}>
          <ExclamationCircleOutlined style={{ margin: '0px 5px', color: '#1677FF' }} />
          该处仅展示未向供应商下单的产品，已下单的产品，请质检员发起退货流程。
        </div>
      </div> : null }
      { type !== 'SUB' ? (<Flex wrap gap={15} style={{ flex: 1, overflowY: 'scroll'}} onScroll={handleScroll} ref={scrollContainerRef} >
        { materialList?.length ? materialList?.map((material: any, index: any) => (
          <Card
            style={{ width: 328, height: 'fit-content' }}
            cover={
              <img
                style={{ width: 328, height: 246 }}
                alt="example"
                src={  type === 'ACTIVITY'
                        ? material?.productSku?.mainPicUrl
                        : material?.productSpu?.mainPicUrl }
                onClick={() => handleShowSpuDetail(material)}
              />
            }
            actions={[
              <div style={{ width: '100%', color: 'var(--theme-color)' }} onClick={() => handleChoose(material, index)}>选择</div>,
            ]}
          >
            <Meta
              title={
                <Tooltip title={material?.productSpuName}>
                  { material?.productSpuName }
                </Tooltip>
              }
              description={(
                <div className={styles.describeBox}>
                  {
                    material.activityProduct ? (
                      <div className={styles.activityInfoBox}>
                        <div className={styles.unit}>
                          限制类型：{ material?.limitTypeName || '-' }
                        </div>
                        <div className={styles.unit}>
                          &nbsp; | &nbsp;剩余数量：{ material?.remainder || '-' }
                        </div>
                      </div>
                    ) : null
                  }
                  <div className={styles.attrBox}>
                    <div className={styles.priceBox}>
                      { (material?.productSkuSalePrice || material?.productSkuSalePrice === 0) ? '￥' + String(material?.productSkuSalePrice) : '' }
                    </div>
                    <div className={styles.unit}>
                      单位：{ material?.productSpuUnitName }
                    </div>
                  </div>
                  <div className={styles.offlineTime}>
                    { material?.outOfStockTime ? dayjs(material?.outOfStockTime).format('YYYY-MM-DD HH:mm') : ''  }
                  </div>
                </div>
              )}
            />
          </Card>
        )) : (
          <div className={styles.noPageBox}>
            <img src={noDataPage} style={{ width: 400, height: 300 }}></img>
          </div>
        )}
      </Flex>) : (
        <Flex wrap gap={15} style={{ flex: 1, overflowY: 'scroll'}} onScroll={handleScroll} ref={scrollContainerRef} >
          { materialList?.length ? (materialList?.map((material: any, index: any) => (
            <Card
              style={{ width: 300, height: 'fit-content' }}
              cover={
                <div style={{ width: 300, height: 160, position: 'relative' }}>
                  <img
                    style={{ width: 300, height: 160 }}
                    alt="example"
                     src={ material?.productSku?.mainPicUrl }
                    onClick={() => handleShowSpuDetail(material)}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      left: 0,
                      top: '5px',
                    }}
                  >
                    <STags itemKey={material?.capitalRefType} />
                  </div>
                </div>
              }
              actions={[
                <div style={{ width: '100%', color: 'var(--theme-color)' }} onClick={() => handleChoose(material, index)}>选择</div>,
              ]}
            >
              <Meta
                title={
                  <Tooltip title={material?.referenceName}>
                    { material?.referenceName }
                  </Tooltip>
                }
                description={(
                  <div className={styles.describeBox}>
                    <div className={styles.attrBox} style={{ marginBottom: '10px '}}>
                      <div className={styles.unit}>
                        单价：{ (material?.saleCustPrice || material?.saleCustPrice === 0) ? '￥' + String(material?.saleCustPrice) : '' }
                      </div>
                      <div className={styles.unit}>
                        单位：{ material?.unitName }
                      </div>
                    </div>
                      <div className={styles.attrBox} style={{ marginBottom: '10px ' }}>
                        <div className={styles.unit}>
                          可减量：{material?.availableQuantity || '-'}
                        </div>
                        {material?.refTypeName === '增项' ? (
                          <div className={styles.unit}>
                            资金池：
                            {material?.capitalAmount || material?.capitalAmount === 0
                              ? '￥' + String(material?.capitalAmount)
                              : '-'}
                          </div>
                        ) : null}
                      </div>
                      <div className={styles.attrBox}>
                        <div className={styles.priceBox}>
                          合计：
                          {material?.actCustPrice || material?.actCustPrice === 0
                            ? '￥' +
                              String(
                                (Math.round(material?.actCustPrice * 100000) *
                                  (material?.availableQuantity || 0)) /
                                  100000
                              )
                            : ''}
                        </div>
                      </div>
                    </div>
                )}
              />
            </Card>
          ))) : (
            <div className={styles.noPageBox}>
              <img src={noDataPage} style={{ width: 400, height: 300 }}></img>
            </div>
          )}
        </Flex>
      )}
       <ProductDetailDrawer previewObj={state} setPreviewObj={setState}></ProductDetailDrawer>
       {/* 修改规格 */}
      <ModifyStandard
        open={modifyStandardOpen}
        onCancel={() => {
          setModifyStandardOpen(false)
        }}
        skuList={skuList}
        loading={modifyLoading}
        formList={currentModifyStandardArray}
        title="选择规格"
        onSubmit={onSubmitModifyStandard}
      ></ModifyStandard>
      
    </div>
  )
})
